<template>
  <div>
    <el-card shadow="hover"
             style="margin-bottom: 10px"
             v-show="isClearValivitor">
      <h3>基础信息</h3>
      <div class="warp">
        <page-form :ref-obj.sync="formInfo.ref"
                   permission="goodsManageAdd"
                   :data="formInfo.data"
                   :fileList="formFieldList"
                   :labelWidth="formInfo.labelWidth"
                   :ruleList="formInfo.rules">
          <template v-slot:form-box>
            <el-input v-model="formInfo.data.box"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')">
              <template slot="append">件/箱</template>
            </el-input>
          </template>
          <template v-slot:form-boxWide>
            <el-input v-model="formInfo.data.boxWide"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
          <template v-slot:form-goodsCode>
            {{ formInfo.data.goodsCode }}
          </template>
        </page-form>
        <page-form :ref-obj.sync="formInfo2.ref"
                   permission="goodsManageAdd"
                   :data="formInfo.data"
                   :fileList="formFieldList2"
                   :labelWidth="formInfo2.labelWidth"
                   :ruleList="formInfo2.rules">
          <template v-slot:form-boxLong>
            <el-input v-model="formInfo.data.boxLong"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
          <template v-slot:form-boxHigh>
            <el-input v-model="formInfo.data.boxHigh"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
          <template v-slot:form-weight>
            <el-input v-model="formInfo.data.weight"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">KG</template>
            </el-input>
          </template>
          <template v-slot:form-standardCode>
            <el-input v-model="formInfo.data.standardCode"
                      placeholder="请输入(取值1-9999)"
                      maxlength="4"
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')">
              <template slot="append">箱/板</template>
            </el-input>
          </template>
           <template v-slot:form-expDays>
            <el-input v-model="formInfo.data.expDays"
                      placeholder=""
                      maxlength="4"
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')">
              <template slot="append">天</template>
            </el-input>
          </template>
          <template v-slot:form-salePrice>
            <el-input v-model="formInfo.data.salePrice"
                      placeholder="请输入"
                      maxlength="9">
              <template slot="append">元/件</template>
            </el-input>
          </template>
        </page-form>
      </div>
      <div class="goodsImg">
        <uploadImg ref="uploadImg" :list='formInfo.data.url'></uploadImg>
      </div>
    </el-card>
    <el-card shadow="hover" v-if="goodsManageInfo.isAcc != 1 && editType != 2">
      <h3>费用配置</h3>
      <div class="wrap"
           style="padding: 20px 0 0">
        <!-- 列表 S -->
        <page-table :list="goodsList"
                    :fieldList="fieldList"
                    deleteName="id">
          <template v-slot:col-num1="scope">
            <el-input style="width: 75px!important"
                      type="number"
                      v-model="scope.row.num1"
                      :oninput="`if(value<0){value=0}else{value=parseInt(value)}`"></el-input>箱
          </template>
          <template v-slot:col-ceshi2="scope">
            <el-select v-model="scope.row.ceshi2"
                       placeholder="请选择"
                       clearable>
              <el-option label="箱"
                         value="1"></el-option>
              <el-option label="重量/体积"
                         value="2"></el-option>
            </el-select>
          </template>
          <template v-slot:col-ceshi3="scope">
            <span v-if="scope.row.aaa"></span>
            <span>{{changeCeshi3}}</span>
          </template>
          <template v-slot:col-ceshi4="scope">
            <el-input :disabled="changeCeshi3 == '-'"
                      v-model="scope.row.ceshi4"></el-input>
          </template>
          <template v-slot:col-ceshi5="scope">
            <costConfig :type="scope.row.ceshi2" :formInfos='goodsList.rows[0]' @update="update"></costConfig>
          </template>
        </page-table>
        <!-- 列表 E -->
        <div style="display:flex">
          <label style="color: #696969;">备注：费用不填时，默认按供应商或仓库费用配置计费</label>
        </div>
      </div>
    </el-card>

    <div class="btns" v-if="editType != 2">
      <template v-if="editType == 0">
        <!-- 正常编辑 -->
        <el-button type="primary" @click="submitConfig()">保存</el-button>
      </template>
      <template v-if="editType == 1">
        <!-- 未审商品编辑 -->
        <el-button @click="submitConfig(0)">仅保存</el-button>
        <el-button type="primary" @click="submitConfig(1)">保存并已审</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import pageForm from '@/components/Form/Index'
import pageTable from '@/components/Table/Index'
import costConfig from './components/costConfig'
import goodsManage from '@/store/goodsManage/index.js'
import { GOODSUPDATE } from '@/store/goodsManage/types.js'
import uploadImg from './components/uploadImage'
import mixin from './components/mixin'
import user from '@/store/user/index'
import { GETHECKED } from '@/store/warehouseTactics/types.js'
import managementModel from '@/store/warehouseTactics/index'

export default {
  name: 'goodsedit',
  data () {
    return {
      id: this.$route.params.code,
      type: this.$route.params.type,
      isMdOpen: 0
    }
  },
  components: {
    pageForm,
    pageTable,
    uploadImg,
    costConfig
  },
  created () {
    // Saas端则显示查看商品
    if (this.editType === 2) {
      this.$route.meta.title = '查看商品'
    }
  },
  mounted () {
    console.log(this.$route.params.warehouseCode)
    // this.warehouseCode = this.$route.params.warehouseCode
  },
  watch: {
    goodsManageInfo: {
      deep: true,
      handler (val) {
        val.standardCode = val.standardCode ? parseInt(val.standardCode) : ''
        this.formInfo.data = val
        let {a, b, c} = val.smallestRule
        this.goodsList.rows[0].ceshi4 = val.price
        this.goodsList.rows[0].smallestUnit = val.smallestUnit || 0
        this.goodsList.rows[0].smallestRule = {a: a || 4, b: b || 4, c: c || 4}
        // 费用配置 回显
        switch (val.computeType) {
          case 'RECKON_TYPE_BOX':
            this.goodsList.rows[0].ceshi2 = '1'
            break
          default:
            this.goodsList.rows[0].ceshi2 = '2'
            break
        }
      }
    },
    'goodsList.rows': {
      deep: true,
      handler (val, val2) {
      }
    },
    warehouseCode (newVal) {
      if (newVal) {
        let params = {
          warehouseCode: newVal
        }
        this.$store.dispatch(GETHECKED, params)
        goodsManage.state.goodsManageInfo.warehouseCode = null
      }
    },
    managementModelData (newVal) {
      for (let i = 0; i < newVal.length; i++) {
        if (newVal[i].yocOpenType === 0) {
          if (newVal[i].yocType === 1) this.isMdOpen = 1
        }
      }
    }
  },
  computed: {
    // 用户信息
    userInfo () {
      return user.state.userinfo
    },
    // 表单验证
    formFieldList2 () {
      let a = [
        { label: '供应商1', prop: 'supplierCode', type: 'select', required: true, options: this.supplierSelect, disabled: true },
        { label: '规格', prop: 'standard', type: 'input', min: 0, max: 15 },
        { label: '外箱长', prop: 'boxLong', type: 'slot', required: true, append: 'cm', validator: this.validateBoxLong },
        { label: '外箱高', prop: 'boxHigh', type: 'slot', required: true, append: 'cm', validator: this.validateBoxHigh },
        { label: '外箱毛重', prop: 'weight', type: 'slot', required: true, append: 'KG', validator: this.validateWeight },
        { label: '标准码放数', prop: 'standardCode', type: 'slot', required: true, append: 'KG', validator: this.validateformatNum }
      ]
      if (this.userInfo.identity === 3) {
        a.push({ label: '保质期', prop: 'expDays', type: 'slot', required: false, append: '天' })
      }
      a.push({ label: '销售价', prop: 'salePrice', type: 'slot', required: true, append: '元/件', validator: this.validateformatprice })
      if (this.userInfo.isMdOpen === 1 || this.isMdOpen === 1) {
        return [...a, { label: '保质期', prop: 'expDays', type: 'slot', required: false, append: '天' }]
      } else {
        return a
      }
    },
    // 编辑回显
    goodsManageInfo () {
      return goodsManage.state.goodsManageInfo
    },
    // 仓库编码
    warehouseCode () {
      return goodsManage.state.goodsManageInfo.warehouseCode
    },
    // 计算体积
    allTotal () {
      let { boxWide, boxHigh, boxLong } = this.formInfo.data
      // let {boxHigh, boxLong} = this.formInfo2.data
      if (isNaN(parseFloat(boxWide)) || isNaN(parseFloat(boxHigh)) || isNaN(parseFloat(boxLong))) {
        return ''
      }
      return parseFloat(boxWide) * parseFloat(boxHigh) * parseFloat(boxLong)
    },
    costMask () {
      return goodsManage.state.costMask
    },
    editType () {
      // type 0:正常编辑，1:未审商品编辑，2:Saas端查看操作
      let type = 0
      switch (this.type) {
        case 'verify':
          type = 1
          break
        case 'view':
          type = 2
          break
      }
      return type
    },
    managementModelData () {
      return managementModel.state.managementModelData.obj
    }
  },
  methods: {
    // 保存
    submitConfig (auditFlag = undefined) {
      let flag1 = false
      this.formInfo.ref.validate((valid) => {
        if (valid) {
          flag1 = true
        } else {
          flag1 = false
        }
      })
      let flag2 = true
      this.formInfo2.ref.validate((valid) => {
        if (valid) {
          flag2 = true
        } else {
          flag2 = false
        }
      })
      if (flag1 && flag2) {
        let {rows} = this.goodsList
        let params = {
          ...this.formInfo.data,
          // ...this.formInfo2.data,
          auditFlag,
          computeType: this.goodsList.rows[0].ceshi3,
          price: this.goodsList.rows[0].ceshi4 ? parseFloat(this.goodsList.rows[0].ceshi4).toFixed(2) : null,
          smallestRule: JSON.stringify(rows[0].smallestRule),
          smallestUnit: rows[0].smallestUnit,
          warehouseCode: this.$route.params.warehouseCode
        }
        params.url = this.$refs.uploadImg.getFileList()
        this.$store.dispatch(GOODSUPDATE, params)
      }
    },
    validateformatNum (rule, value, callback) {
      if (Number(value) < 1 || Number(value) > 9999) {
        callback(new Error('请输入1-9999'))
      }
      callback()
    },
    validateformatprice (rule, value, callback) {
      var reg3 = /^(0|([1-9][0-9]*))+(\.[0-9]{1,2})?$/
      if (!value) {
        callback(new Error('请输入销售价'))
      }
      if (Number(value) <= 0 || Number(value) >= 1000000) {
        callback(new Error('销售价需大于0且小于1000000'))
      }
      if (!reg3.test(value)) {
        callback(new Error('只能保留两位小数'))
      }
    },
    validateNum (rule, value, callback, name) {
      if (value) {
        value = value.toString()
      }
      if (!value) {
        callback(new Error('请输入'))
      } else if (value.split('.').length > 2) {
        // 防止输入多个小数点
        callback(new Error('请输入正确的格式'))
      } else {
        // 四舍五入
        value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)
        // 不足补位
        value = Number(value).toFixed(2)
        this.formInfo.data[name] = value

        callback()
      }
    },
    valformatNum (rule, value, callback, name) {
      // 四舍五入
      value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)
      // 不足补位
      // value = Number(value).toFixed(2)
      if (name === 'standardCode') {
        this.formInfo.data[name] = value
      } else {
        this.formInfo2.data[name] = value
      }
      callback()
    }
  },
  mixins: [mixin]
}
</script>

<style scoped>
.warp {
  display: flex;
  padding: 20px 50px 0;
}
.warp >>> .el-form:last-child {
  margin-left: 100px;
}
.warp,
.goodsImg {
  display: flex;
  padding: 20px 50px 0;
}
.btns {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 32px;
  box-shadow: 2px 0 4px rgb(0 0 0 / 20%);
  margin: auto;
  padding: 17px 25px 17px 225px;
  z-index: 4;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/page/goodsManage/GoodsEdit.vue